// Polyfills
import "dialog-closedby-polyfill"

// Rails
import './controllers'

// Custom Turbo stream actions
import "./turbo_stream_actions/fetch_stream"
import "./turbo_stream_actions/set_attribute"
import "./turbo_stream_actions/visit"
